module.exports = __webpack_public_path__ + "static/karnail-91e41d50b812f6be492925ed04d47a0c.jpg";